/**
 * Self-hosted web fonts offered in the portal Font Family setting, in addition to the
 * original noto-sans / montserrat / inter fonts handled directly in FontService.
 *
 * Files are the Fontsource (Google Fonts, OFL/Apache licensed) latin + latin-ext subsets, stored at
 *   fonts/<value>/<value>-<subset>-<weight>-<style>.woff2
 * in the prweb-assets-prod bucket. Each font has every listed weight in normal style plus 400 italic.
 */
export interface WebFont {
  name: string;
  value: string;
  fallback: "sans-serif" | "serif";
  weights: number[];
}

export const WEB_FONT_BASE_URL = "https://prweb-assets-prod.s3.amazonaws.com/fonts";

export const WEB_FONT_SUBSETS = [
  {
    subset: "latin-ext",
    unicodeRange: "U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF",
  },
  {
    subset: "latin",
    unicodeRange: "U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD",
  },
];

export const WEB_FONTS: WebFont[] = [
  { name: "Figtree", value: "figtree", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Fira Sans Condensed", value: "fira-sans-condensed", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Lato", value: "lato", fallback: "sans-serif", weights: [300, 400, 700, 900] },
  { name: "Merriweather", value: "merriweather", fallback: "serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Nunito", value: "nunito", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Open Sans", value: "open-sans", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800] },
  { name: "Playfair Display", value: "playfair-display", fallback: "serif", weights: [400, 500, 600, 700, 800, 900] },
  { name: "Poppins", value: "poppins", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Raleway", value: "raleway", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Roboto", value: "roboto", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Source Sans 3", value: "source-sans-3", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Source Serif 4", value: "source-serif-4", fallback: "serif", weights: [300, 400, 500, 600, 700, 800, 900] },
  { name: "Work Sans", value: "work-sans", fallback: "sans-serif", weights: [300, 400, 500, 600, 700, 800, 900] },
];
